import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';

import { ReviewsResults } from '../../commons/helpers';

const SearchReviewsContent = ({
  indexName,
  searchClient,
  searchState,
  searchStateQuery,
  updateSearchPage,
}) => (
  <div className="w-full">
    <InstantSearch
      searchClient={searchClient}
      /* TODO: CON-7887: (Codemod generated): `searchState` is no longer supported. This is now handled via an `onStateChange` callback.
      See https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/react-hooks/#replace-searchstate-with-initialuistate */
      searchState={searchState}
      indexName={indexName}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={9}
        facetFilters={searchState.configure.facetFilters}
      />

      <ReviewsResults onLoadMore={updateSearchPage} variant="advanced-search" />
    </InstantSearch>
  </div>
);

export default SearchReviewsContent;
